import styled from "styled-components";
import { Box } from "@mui/material";

export const ImageSlideShowContainer = styled(Box)`
	padding-top: 40px;
	.image-gallery-content .image-gallery-slide .image-gallery-image {
		max-height: calc(100vh - 200px);
	}
`;
